import { render, staticRenderFns } from "./FixitLogin.vue?vue&type=template&id=50495151"
import script from "./FixitLogin.vue?vue&type=script&lang=js"
export * from "./FixitLogin.vue?vue&type=script&lang=js"
import style0 from "./FixitLogin.vue?vue&type=style&index=0&id=50495151&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports